/** Google Müşteri Yorumları — Merchant Center kayıt entegrasyonu */
export const GOOGLE_MERCHANT_ID = 5711262654;

const SCRIPT_ATTR = 'data-google-review-optin';
const SCRIPT_SRC = 'https://apis.google.com/js/platform.js?onload=renderOptIn';

export const addBusinessDays = (startDate, days) => {
  const result = new Date(startDate);
  let added = 0;
  const target = Math.max(1, days);
  while (added < target) {
    result.setDate(result.getDate() + 1);
    if (result.getDay() !== 0 && result.getDay() !== 6) {
      added += 1;
    }
  }
  return result.toISOString().split('T')[0];
};

const collectProductGtins = (order) => {
  const items = order?.items || order?.OrderItems || [];
  if (!Array.isArray(items)) return [];
  return items
    .map((item) => {
      const gtin =
        item.gtin ||
        item.barcode ||
        item.product?.gtin ||
        item.product?.barcode;
      return gtin ? { gtin: String(gtin) } : null;
    })
    .filter(Boolean);
};

export const buildGoogleReviewOptInPayload = (order, { estimatedBusinessDays = 5 } = {}) => {
  const email =
    order.contactInfo?.email ||
    order.guest_email ||
    order.contact_email ||
    order.billing_email;

  const orderIdValue = String(order.order_number || order.id);
  const isExpress =
    order.delivery_method === 'express' || order.deliveryMethod === 'express';
  const businessDays = isExpress
    ? Math.min(estimatedBusinessDays, 2)
    : estimatedBusinessDays;

  const countryRaw = order.shipping_country || order.shippingCountry || 'TR';
  const deliveryCountry =
    countryRaw === 'Türkiye' || countryRaw === 'Turkey' ? 'TR' : String(countryRaw).slice(0, 2).toUpperCase();

  const payload = {
    merchant_id: GOOGLE_MERCHANT_ID,
    order_id: orderIdValue,
    email,
    delivery_country: deliveryCountry,
    estimated_delivery_date: addBusinessDays(
      new Date(order.createdAt || order.created_at || Date.now()),
      businessDays
    ),
  };

  const products = collectProductGtins(order);
  if (products.length > 0) {
    payload.products = products;
  }

  return payload;
};

let lastRenderedOrderId = null;

export const renderGoogleCustomerReviewsOptIn = (order, options) => {
  if (!order || order.payment_status !== 'odendi') return false;

  const payload = buildGoogleReviewOptInPayload(order, options);
  if (!payload.email || !payload.order_id) return false;

  if (lastRenderedOrderId === payload.order_id) return true;
  lastRenderedOrderId = payload.order_id;

  window.renderOptIn = function renderOptIn() {
    if (!window.gapi?.load) return;
    window.gapi.load('surveyoptin', function onSurveyOptInLoaded() {
      window.gapi.surveyoptin.render(payload);
    });
  };

  const existingScript = document.querySelector(`script[${SCRIPT_ATTR}="true"]`);
  if (existingScript && window.gapi) {
    window.renderOptIn();
    return true;
  }

  if (existingScript) {
    return true;
  }

  const script = document.createElement('script');
  script.src = SCRIPT_SRC;
  script.async = true;
  script.defer = true;
  script.setAttribute(SCRIPT_ATTR, 'true');
  document.body.appendChild(script);
  return true;
};
